<div class="mt-6">
  <app-floating-input
    (ngModelChange)="onTextModelChange($event)"
    [ngModel]="textModel()"
    [name]="name() + '-input'"
    [label]="label()"
    [minlength]="minlength()"
    [maxlength]="maxlength()"
    [tooltipText]="toolTip()"
    [required]="required()"
    (enterPressed)="enterPressed($event)"
    [customError]="!ngControl().control.valid && ngControl().control.touched ? 'Tags should be unique.' : ''"
  ></app-floating-input>
  @if (tags().length) {
    <app-tags [tags]="tags()" (tagRemoved)="removeTag($event)" />
  }
</div>
